import './ccf-no-assignment-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * Component used to show add channel Icon
 * @param props - SvgIconProps
 * @example - <CcfNoAssignmentIcon />
 * @returns SVG of no assignment icon
 */
export function CcfNoAssignmentIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg        
        viewBox="0 0 50 44"
        fill="none"        
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.0525 27.25L37.99 16.834H12.0095L7.81421 23.084H7.83374L5.05054 27.25H18.7495C18.7495 30.7012 21.5484 33.5 24.9995 33.5C28.4507 33.5 31.2495 30.7012 31.2495 27.25H45.0525ZM49.9998 27.25V43.916H-0.000244141V27.25L9.78876 12.666H40.2108L49.9998 27.25ZM15.4488 31.416H4.16576V39.75H45.8338V31.416H34.5508C32.9434 35.0957 29.2713 37.666 24.9998 37.666C20.7283 37.666 17.0563 35.0957 15.4488 31.416V31.416ZM27.0838 8.5H22.9158V0.165999H27.0838V8.5ZM37.0368 9.8086L33.7965 7.1914L38.8435 0.9414L42.0857 3.5586L37.0368 9.8086ZM16.2028 7.1914L12.9625 9.8086L7.91351 3.5586L11.1557 0.9414L16.2028 7.1914Z"
          fill="#929292"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfNoAssignmentIcon;
